import { questionnaireSubmissionService } from "@/apis/services/questionnaire-submissions/questionnaireSubmission.service"
import { IQuestionnaireSubmission, IQuestionnaireSubmissionDto } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IQuestionnaireSubmissionState {
  currentSubmission: IQuestionnaireSubmission | null
  isLoading: boolean
  error: string | null
  createQuestionnaireSubmission: (dto: IQuestionnaireSubmissionDto) => Promise<IQuestionnaireSubmission>
}

const initialState = {
  currentSubmission: null,
  isLoading: false,
  error: null,
}

export const useQuestionnaireSubmissionStore = create<IQuestionnaireSubmissionState>()(
  devtools(set => ({
    ...initialState,

    createQuestionnaireSubmission: async (dto: IQuestionnaireSubmissionDto): Promise<IQuestionnaireSubmission> => {
      set({ isLoading: true, error: null })
      try {
        const response = await questionnaireSubmissionService.createQuestionnaireSubmission(dto)
        set({ currentSubmission: response.data })
        return response.data
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
